export const NewContactForm = (function () {

    let formToJson = function (form) {
        let object = {};
        let elements = form.querySelectorAll('input, select, textarea');

        [].forEach.call(elements, function (element) {
            if (!element.name) {
                return;
            }

            object[element.name] = element.value;
        });

        return JSON.stringify( object );
    };

    return function (wrapperElement) {
        let wrapper = wrapperElement;
        let form = wrapper.querySelector('.new-contact-form');
        let globalPopup = document.getElementById('global-popup-contact');
        let projectRadios = form.querySelectorAll('input[type="radio"][name="projectChoice"]');

        window.formLabel = form.type.value;

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            this.send();
        }.bind(this));

        // When the user picks a project in the multi-project picker, copy that
        // option's data-* attributes onto the hidden inputs so the backend
        // (and Knips) receive the correct estate identifiers.
        [].forEach.call(projectRadios, function (radio) {
            radio.addEventListener('change', function () {
                if (!radio.checked) return;
                if (form.knipsId)     form.knipsId.value     = radio.dataset.knipsId     || 0;
                if (form.useKnips)    form.useKnips.value    = radio.dataset.useKnips    || 0;
                if (form.vitecId)     form.vitecId.value     = radio.dataset.vitecId     || 0;
                if (form.useVitec)    form.useVitec.value    = radio.dataset.useVitec    || 0;
                if (form.estateLabel) form.estateLabel.value = radio.dataset.estateLabel || '';
                if (form.estateTitle) form.estateTitle.value = radio.dataset.estateTitle || '';
            });
        });



       this.showOverlay = function () {
            wrapper.classList.add('overlay');
            wrapper.classList.remove('success');
            wrapper.classList.remove('error');
        };

        this.showSuccess = function () {
            wrapper.classList.add('success');
            wrapper.classList.remove('overlay');
            wrapper.classList.remove('error');
        };

        this.showError = function () {
            wrapper.classList.add('error');
            wrapper.classList.remove('overlay');
            wrapper.classList.remove('success');
            setTimeout(function(){
                wrapper.classList.remove('error');
            },3000);
        };
        
        this.send = function () {

            // Read fresh each submit so values updated by the project picker
            // (knipsId, useKnips, estateLabel, estateTitle) are picked up.
            this.data = {
                formType: form.formType.value,
                useKnips: form.useKnips.value,
                useVitec: form.useVitec.value,
                knipsId: form.knipsId ? form.knipsId.value : 0,
                vitecId: form.vitecId ? form.vitecId.value : 0,
                estateLabel: form.estateLabel ? form.estateLabel.value : '',
                estateTitle: form.estateTitle ? form.estateTitle.value : '',
            };

            this.data.description = form.description.value;
            this.data.user_address = form.user_address.value;
            this.data.username = form.username.value;
            this.data.email = form.email.value;

            if(this.data.formType == 'project'){
                this.data.firstName = form.firstName.value;
                this.data.lastName = form.lastName.value;
                this.data.phone = form.phone.value;
                this.data.newsletter = form.newsletter && form.newsletter.checked ? 1 : 0;
                this.data.fullName = this.data.firstName + " " + this.data.lastName;
            }

            console.log(this.data);
            this.showOverlay();
            let fData = new FormData(form);
            Object.keys(this.data).forEach(function (key) {
                fData.append(key, this.data[key]);
            }.bind(this));
            fData.append('CRAFT_CSRF_TOKEN', form.querySelector('[name="CRAFT_CSRF_TOKEN"]').value);
            fData.append('action','vitecbroker/broker/newsletter-form');

            fetch('/', {
                method: 'POST',
                headers: {'Accept': 'application/json'},
                body: fData
            }).then(function (res) {
                return res.json();
            }).then(function (result) {
                console.log(result);
                if (result.success) {
                    this.showSuccess();

                    if (window.dataLayer) {
                        window.dataLayer.push({
                            'event': 'eventTracking',
                            'eventCategory': 'Meld interesse',
                            'eventAction': 'sent',
                            'eventLabel': window.formLabel
                        });
                    }

                    if (window.d2_cookies) {
                        window.d2_cookies.subscriptionRegistered();
                    }

                    if(globalPopup) {
                        setTimeout(function () {
                            globalPopup.classList.remove('active');
                        }, 3000);
                    }
                    
                }else {
                    this.showError();
                }
            }.bind(this)).catch(function (e) {
                console.log(e);
                this.showError();
            }.bind(this));
        };
    };
} ());